// Tailwind-style green ramp, 25-step notation, centered on #16a34a
const aquanowGreen = {
    '25':  '#f6fdf8',  // very light green tint
    '50':  '#ecfdf5',  // Tailwind green-50
    '100': '#d1fae5',  // Tailwind green-100
    '150': '#b7f2d6',  // custom tint
    '200': '#a7f3d0',  // Tailwind green-200
    '250': '#89e7bc',  // custom tint
    '300': '#6ee7b7',  // Tailwind green-300
    '350': '#4dd797',  // custom tint
    '400': '#34d399',  // Tailwind green-400
    '450': '#2ec57f',  // custom shade
    '500': '#22c55e',  // Tailwind green-500
    '550': '#1fb856',  // custom shade
    '600': '#16a34a',  // Tailwind green-600 ← base
    '650': '#149843',  // custom shade
    '700': '#15803d',  // Tailwind green-700
    '750': '#126b35',  // custom shade
    '800': '#166534',  // Tailwind green-800
    '850': '#14572f',  // custom shade
    '900': '#14532d',  // Tailwind green-900
    '950': '#0f291e',  // Tailwind green-950
    '975': '#0b1c14',  // custom shade for ultra dark
};
  
  export default aquanowGreen;